import {EventEmitter, Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {ScenariosCommandHandlerBase} from '@features/scenarios-core/services/handlers/scenarios-command-handler-base';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';

@Injectable({
  providedIn: 'root'
})
export class OpenCalculatorCommandHandler extends ScenariosCommandHandlerBase  implements IPlatformCommandHandler {

  constructor( public router: Router,
               public commandService: CommandService,
               public fuseSplashScreenService: FuseSplashScreenService,
               public snackBarService: SnackBarService) {
    super(router, commandService, fuseSplashScreenService, snackBarService);
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
      command.fieldValues['ExpiryDate'] = new Date();
      console.log('[OpenCalculatorCommandHandler] Inside Execute Command from ');
      this.executeCommandToApi(command, handler);
      return true;
  }
}
